import { Chart, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';

Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: true,
      position: 'top',
      labels: {
        boxWidth: 20,
        borderRadius:10,
      },
    },
    title: {
      display: false,
    },
  },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

const clicksData = {
  label: 'Clicks',
  data: labels.map(() => Math.floor(Math.random() * 500)),
  borderColor: '#333333',
  backgroundColor: '#333333',
  fill: false,
};

const impressionsData = {
  label: 'Impressions',
  data: labels.map(() => Math.floor(Math.random() * 1000)),
  borderColor: '#8CC9E9',
  backgroundColor: '#8CC9E9',
  fill: false,
};

const invitesData = {
  label: 'Invites',
  data: labels.map(() => Math.floor(Math.random() * 200)),
  borderColor: '#8CE9DB', 
  backgroundColor: '#8CE9DB',
  fill: false,
};

const data = {
  labels,
  datasets: [impressionsData, clicksData, invitesData],
};

export default function AdChart() {
  const customWidth = 1000;
  const customHeight = 280;

  return <Line options={options} data={data} width={customWidth} height={customHeight} />;
}
